
import Vue from "vue";
import Router from 'vue-router';
import Cross from '../pages/Cross.vue';
import Home from '../pages/Home.vue';
import UserIncentive from '../pages/UserIncentive.vue';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/home/crosses',
      name: 'crosses',
      component: Cross,
      props: true
    },
    {
      path: '/home/crosses/:code',
      name: 'cross_detail',
      component: Cross,
      props: true
    },
    {
      path: '/home/user_incentives',
      name: 'user_incentive',
      component: UserIncentive,
      props: true
    }
  ]
});

export default router;